"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FeedUserType = {
  Unknown: 0,
  Hudl: 1,
  Team: 2,
  User: 3
};

exports.default = FeedUserType;